import { useState, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ChamProjectsOpenButton } from '../../shared/ChamProjects/ChamProjects';
import { resetVisualizer, setActiveFloorplanId } from '../../../store/visualizerSlice';
import hollandLogo from '../../shared/TopMenu/assets/holland-logo.png';
import styles from './LandingPage.module.css';

export default function LandingPage() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { floorplans } = useSelector(state => state.floorplan);

    // Build [{ id, name }] from active floorplans (already filtered in slice)
    const planOptions = useMemo(() => {
        return (floorplans || [])
            .map(fp => ({
                id: fp.Id || fp.id,
                name: fp.Name || fp.name
            }))
            .filter(p => p.id != null && p.name)
            .filter(p => !/elevate/i.test(p.name));
    }, [floorplans]);

    const [selectedId, setSelectedId] = useState('');

    const handleGetStarted = () => {
        if (!selectedId) return;
        dispatch(resetVisualizer());
        dispatch(setActiveFloorplanId(selectedId));
        navigate(`/visualizer/${selectedId}`);
    };

    return (
        <div className={styles.landingPage}>
            {/* Top bar with logo + My Projects */}
            <header className={styles.topBar}>
                <div className={styles.logo}>
                    <img src={hollandLogo} alt="Holland Homes" />
                </div>
                <ChamProjectsOpenButton title="My Projects" className={styles.myProjectsLink} />
            </header>

            {/* Background image */}
            <div
                className={styles.bgImage}
                style={{ backgroundImage: `url('/images/landing/landing.jpg')` }}
            />
            <div className={styles.bgOverlay} />

            {/* Center content */}
            <div className={styles.centerContent}>
                <h1 className={styles.title}>Home Building Design Guide</h1>
                <h2 className={styles.subtitle}>Visualize your homes selection</h2>
                <p className={styles.helperText}>Select your community before beginning</p>

                <div className={styles.formControls}>
                    <select
                        className={styles.planSelect}
                        value={selectedId}
                        onChange={(e) => setSelectedId(e.target.value)}
                    >
                        <option value="">Select Community</option>
                        {planOptions.map(p => (
                            <option key={p.id} value={p.id}>{p.name}</option>
                        ))}
                    </select>

                    <button
                        className={styles.getStartedButton}
                        onClick={handleGetStarted}
                        disabled={!selectedId}
                    >
                        Get Started
                    </button>
                </div>
            </div>
        </div>
    );
}
